import { atom } from 'recoil';
import { StoreWithId } from '~/types/store';

const store = atom<StoreWithId | null>({
  key: 'store',
  default: null,
});

export default store;
